//在vue组件中访问vuex模块中的getters/action/state https://www.cnblogs.com/caimuguodexiaohongmao/p/11854228.html
//https://vuex.vuejs.org/zh/guide/getters.html
export default{
    namespaced: true,
    state:{
        //导出中
        inTheOrderExport:false,  
      },
    mutations:{
         SET_ORDER_EXPORT_FLAG(state,value){
            state.inTheOrderExport=value;
         }     
    },
    actions:{
        saveOrderExportFlag({commit},value){
            commit("SET_ORDER_EXPORT_FLAG",value);
        }
        
    },
    

}


// WEBPACK FOOTER //
// ./src/store/modules/constants.js